import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, getComicsByCategory } from '@/mocks/comics';
import ComicCard from '@/pages/home/components/ComicCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryComics = slug ? getComicsByCategory(slug) : [];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: currentCategory ? `${currentCategory.name}漫画 - 韩漫网` : '漫画分类 - 韩漫网',
    description: currentCategory
      ? `在韩漫网免费在线看${currentCategory.name}漫画，精选海量优质${currentCategory.name}类韩国漫画资源，更新快速，画质高清。`
      : '韩漫网漫画分类浏览，涵盖热血、爱情、冒险、奇幻、搞笑、悬疑等多种题材。',
    url: `https://www.hanmanwang.com/category/${slug}`,
    isPartOf: { "@id": "https://www.hanmanwang.com/#website" },
  };

  if (!currentCategory) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen pt-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
              <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
            </div>
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-2">分类未找到</h1>
            <p className="text-foreground-600 mb-6">抱歉，您查找的漫画分类不存在。</p>
            <Link to="/" className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-16 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: `${currentCategory.name}漫画` },
            ]}
          />

          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${currentCategory.icon} text-lg text-primary-500`}></i>
              </div>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {currentCategory.name}漫画
              </h1>
            </div>
            <p className="text-sm text-foreground-600 ml-13 md:ml-0 md:pl-13">
              精选{currentCategory.name}类韩国漫画，持续更新中
            </p>
          </div>

          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 pb-16">
            {categoryComics.map((comic, idx) => (
              <div
                key={comic.id}
                className="animate-fade-in"
                style={{ animationDelay: `${idx * 0.06}s` }}
              >
                <ComicCard comic={comic} />
              </div>
            ))}
          </div>

          {categoryComics.length === 0 && (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                <i className="ri-inbox-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-600">该分类暂无漫画，敬请期待</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}